import { render, staticRenderFns } from "./UserInformation.vue?vue&type=template&id=4fe0cd7e"
import script from "./UserInformation.vue?vue&type=script&lang=js"
export * from "./UserInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports